import { getRandomItem } from "./random";
export const teamNameMap = {
    "ac-oulu": "AC Oulu",
    "fc-inter": "FC Inter",
    "fc-lahti": "FC Lahti",
    "ff-jaro": "FF Jaro",
    gnistan: "Gnistan",
    hjk: "HJK",
    "ifk-mariehamn": "IFK Mariehamn",
    ilves: "Ilves",
    kups: "KuPS",
    sjk: "SJK",
    tps: "TPS",
    vps: "VPS",
};
const teams = Object.entries(teamNameMap).reduce((teams, [teamId, teamName]) => (Object.assign(Object.assign({}, teams), { [teamId]: {
        id: teamId,
        name: teamName,
        logoUrl: `/images/team-logos/${teamId}.png`,
    } })), {});
/**
 * Get team information for provided team ID.
 * @param id Team ID (lower-case and without scandinavian characters)
 */
export function getTeam(id) {
    var _a;
    return (_a = teams[id]) !== null && _a !== void 0 ? _a : null;
}
export function getRandomOpponentTeam() {
    return getTeam(getRandomItem(Object.keys(teams).filter((team) => team !== "ilves")));
}
